import type { BaseSlideProps, ScenarioContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function ScenarioSlide({ title, content, accentColor }: BaseSlideProps) {
  const { scenarios } = content as ScenarioContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 text-center accent-text">
        {title}
      </h2>

      <div className="space-y-8">
        {scenarios.map((scenario, idx) => (
          <div
            key={idx}
            className="card accent-border-left animate-fade-in-up"
            style={{ animationDelay: `${idx * 0.15}s` }}
          >
            <h3 className="font-serif font-semibold text-2xl mb-4 accent-text">
              {scenario.title}
            </h3>

            <div className="space-y-4">
              {/* Setup */}
              <div>
                <p className="text-sm font-medium text-slate-600 dark:text-slate-400 mb-1">
                  Setup:
                </p>
                <p className="text-slate-700 dark:text-slate-300"
                   dangerouslySetInnerHTML={{ __html: inlineMarkdown(scenario.setup) }} />
              </div>

              {/* Roles split */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-4">
                  <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
                    Human Role
                  </p>
                  <p className="text-sm text-slate-700 dark:text-slate-300"
                     dangerouslySetInnerHTML={{ __html: inlineMarkdown(scenario.humanRole) }} />
                </div>

                <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-4">
                  <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
                    AI Role
                  </p>
                  <p className="text-sm text-slate-700 dark:text-slate-300"
                     dangerouslySetInnerHTML={{ __html: inlineMarkdown(scenario.aiRole) }} />
                </div>
              </div>

              {/* Outcome */}
              <div className="accent-bg-lighter rounded-lg p-4 mt-4">
                <p className="text-sm font-medium accent-text-dark mb-1">
                  Outcome:
                </p>
                <p className="text-sm text-slate-700 dark:text-slate-300"
                   dangerouslySetInnerHTML={{ __html: inlineMarkdown(scenario.outcome) }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
